import { render, staticRenderFns } from "./IdeasLayout.vue?vue&type=template&id=cd1d13ea&scoped=true&"
import script from "./IdeasLayout.vue?vue&type=script&lang=js&"
export * from "./IdeasLayout.vue?vue&type=script&lang=js&"
import style0 from "./IdeasLayout.vue?vue&type=style&index=0&id=cd1d13ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1d13ea",
  null
  
)

export default component.exports